import React from 'react';
import './index.less';
import RatingOption from './RatingOption';

const RatingScale = ({ options, onChange, value, readOnly }) => {
    return (
        <div className='rating-scale'>
            {options.map(({ icon, color, label, score }, index) => (
                <RatingOption
                    key={index}
                    active={score === value}
                    icon={icon}
                    color={color}
                    label={label}
                    onChange={() => onChange(score === value ? null : score)}
                    readOnly={readOnly}
                    withBorder
                />
            ))}
        </div>
    );
};

RatingScale.defaultProps = {
    variant: '',
};

export default RatingScale;
